// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { gnosisChiado as _gnosisChiado } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the gnosisChiado chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 10200
 * Chain Name: Gnosis Chiado
 * Default Block Explorer: https://blockscout.chiadochain.net
 * Default RPC URL: https://rpc.chiadochain.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { gnosisChiado } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: gnosisChiado,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const gnosisChiado = createCommon({
	..._gnosisChiado,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
